import { defineStore } from 'pinia';
import { createExploreFeedFetchOptions } from '@/domain/market/explore-feed-adapter.js';
import {
  paginatedFeedOnContainerScroll,
  paginatedFeedRecoverIfStuck,
} from '@/domain/market/paginated-feed-core.js';
import { runPaginatedFeedFetchPage, runPaginatedFeedLoadMore } from '@/stores/feed-fetch-error.js';
import { shouldIgnoreFeedScrollLoad } from '@/composables/feed-viewport.js';
import { paginatedFeedIsManualLoadRequired } from '@/domain/market/paginated-feed-pagination.js';

const exploreFetchOptions = createExploreFeedFetchOptions();

/**
 * 探索页（推荐）collection/page 状态（与首页 marketFeed 隔离，避免 keep-alive 互相污染）
 */
export const useExploreFeedStore = defineStore('exploreFeed', {
  state: () => ({
    initialized: false,
    rawRows: [],
    listLoading: false,
    loadingMore: false,
    hasMore: true,
    pageNum: 0,
    loadGeneration: 0,
    lastFetchPlatform: 'pc',
    autoAppendCount: 0,
    appendAutoLoadBlocked: false,
    listFetchError: null,
  }),

  getters: {
    showListEmpty(state) {
      return !state.listLoading && !state.loadingMore && state.rawRows.length === 0;
    },
    manualLoadRequired(state) {
      return paginatedFeedIsManualLoadRequired(state);
    },
  },

  actions: {
    setLastFetchPlatform(isH5) {
      this.lastFetchPlatform = isH5 ? 'h5' : 'pc';
    },

    async ensureInit() {
      if (this.initialized && this.rawRows.length) return;
      this.recoverIfStuck();
      if (this.initialized && this.rawRows.length) return;
      await this.fetchPage(false);
    },

    recoverIfStuck() {
      paginatedFeedRecoverIfStuck(this);
    },

    _fetchOptions(extra = {}) {
      return {
        ...exploreFetchOptions,
        ...extra,
      };
    },

    async fetchPage(append = false, options = {}) {
      await runPaginatedFeedFetchPage(this, append, this._fetchOptions(options));
    },

    async loadMore(options = {}) {
      await runPaginatedFeedLoadMore(this, this._fetchOptions(options));
    },

    onContainerScroll(container) {
      paginatedFeedOnContainerScroll(this, container, {
        fetchOptions: this._fetchOptions(),
        shouldIgnoreScrollLoad: shouldIgnoreFeedScrollLoad,
      });
    },
  },
});
